import React from 'react';
import UtilityService from '../../../services/UtilityService';

export const CustomMessageTestId = 'custom-messages-content';

export type CustomMessagesProps = {
  customMessage: string;
};

const CustomMessage: React.FC<CustomMessagesProps> = ({
  customMessage,
}: CustomMessagesProps) => {
  return (
    <div
      className="text-xs mb-4 mx-2"
      data-testid={CustomMessageTestId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: UtilityService.sanitizeHtml(customMessage),
      }}
    />
  );
};

export default CustomMessage;
